import React from 'react';
import { Link } from 'react-router-dom';
import Brand from './Brand';
import './Footer.css';

function Footer() {
  return (
    <footer className="vanir-footer">
      <div className="vanir-footer__main">
        <div className="vanir-footer__intro"><Link to="/" aria-label="Vanir Motor Group home"><Brand light /></Link><p>Commercial vehicles.<br />Built around your business.</p><p className="vanir-footer__public">Business customers and the public welcome.</p></div>
        <nav aria-label="Rental and hire" className="vanir-footer__links">
          <h2>Find your van</h2><Link to="/van-rental">Short-term rental</Link><Link to="/van-hire">3–12 month hire</Link><Link to="/our-vans/ford/transit-custom">Ford Transit Custom</Link><Link to="/electric-hybrid-vans">Electric & hybrid vans</Link><Link to="/business-van-hire">Business & fleet</Link><Link to="/vehicle-sales">Vehicle sales</Link>
        </nav>
        <nav aria-label="Useful information" className="vanir-footer__links">
          <h2>Here to help</h2><Link to="/about">About</Link><Link to="/request-a-quote">Request a quote</Link><Link to="/contact">Contact our team</Link><Link to="/terms">Terms & conditions</Link><Link to="/privacy">Privacy policy</Link><Link to="/cookies">Cookies</Link><Link to="/complaints">Complaints</Link><Link to="/tcf">Treating Customers Fairly</Link>
        </nav>
        <div className="vanir-footer__contact"><h2>Let’s talk vans</h2><a className="vanir-footer__phone" href="tel:01516731916">0151 673 1916</a><a href="mailto:rental@vanirmotorgroup.com">rental@vanirmotorgroup.com</a><address>Unit 1A Crystal Trading Estate<br />Old Racecourse Road<br />Liverpool, L31 8AW</address><span className="vanir-footer__delivery">Delivery available nationwide</span></div>
      </div>
      <div className="vanir-footer__disclosure">
        <p>
          &copy; 2024 Vanir Motor Group is a trading style of Vanir Fleet Services.
        </p>
        <p>
          VANIR FLEET SERVICES LTD (FRN 1033348) is an Introducer Appointed Representative of Jigsaw Finance Limited, who is authorised and regulated by the Financial Conduct Authority. FRN 679612. Jigsaw Finance Limited is a credit broker and not a lender.
        </p>
        <p>
          Company registration number: 16192767 VAT Number: 486347158 ICO registration number ZB903098
        </p>
      </div>
    </footer>
  );
}

export default Footer;
